var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenuCosting = function SvgMenuCosting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2592 5.33334H8.7407C7.59522 5.33334 6.66663 6.52725 6.66663 8.00001V26.6667C6.66663 28.1394 7.59522 29.3333 8.7407 29.3333H23.2592C24.4047 29.3333 25.3333 28.1394 25.3333 26.6667V8.00001C25.3333 6.52725 24.4047 5.33334 23.2592 5.33334Z",
    stroke: "#363840",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 20.9068C21.3333 20.9068 18.9455 20.9068 16 20.9068C13.0544 20.9068 10.6666 20.9068 10.6666 20.9068C10.6666 17.9612 13.0544 15.5734 16 15.5734C18.9455 15.5734 21.3333 17.9612 21.3333 20.9068Z",
    stroke: "#363840",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59998 20.9068H22.4",
    stroke: "#363840",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 13.8667C17 13.3144 16.5523 12.8667 16 12.8667C15.4477 12.8667 15 13.3144 15 13.8667H17ZM15 13.8667V16H17V13.8667H15Z",
    fill: "#363840"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3185 3.84012H12.6814C12.1578 3.84012 11.7333 4.05237 11.7333 4.31419V7.63271C11.7333 7.89454 12.1578 8.10679 12.6814 8.10679H19.3185C19.8421 8.10679 20.2666 7.89454 20.2666 7.63271V4.31419C20.2666 4.05237 19.8421 3.84012 19.3185 3.84012Z",
    fill: "white",
    stroke: "#363840",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgMenuCosting;